// @flow
import styled from 'styled-components';
import PayerFooter from 'assets/icons/payer-footer.svg';

import FaqLink from 'components/faq-link';

import { TYPE_SCALE_F0, TYPE_SCALE_F3 } from 'styles/type-scale';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { CLARK_SECONDARY } from 'styles/colors';
import { LINE_HEIGHT_TITLE, LINE_HEIGHT_COPY } from 'styles/line-height';
import { SPACING_LARGE, SPACING_MEDIUM, SPACING_SMALL } from 'styles/spacing';

// This Copy component shouldn't be a div;
// it is right now because FaqLink is inside it in the JSX above,
// which is implemented as a div;
// FaqLink should probably become not a div to resolve this and
// make that component more globally useful
// - MP 11.1.2018
export const Copy = styled.div`
  ${TYPE_SCALE_F3};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
`;

export const Faq = styled<any>(FaqLink)`
  ${TYPE_SCALE_F3};
`;

export const FlexCol = styled.div`
  height: 100vh;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Headline = styled.h1`
  ${TYPE_SCALE_F0};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_TITLE};
  color: ${CLARK_SECONDARY};
  margin: ${SPACING_LARGE} 0 calc(${SPACING_MEDIUM} + ${SPACING_SMALL}) 0;
`;

// $FlowFixMe
export const WidePayerFooter = styled<any>(PayerFooter)`
  width: 100%;
  margin-top: ${SPACING_LARGE};
`;



// WEBPACK FOOTER //
// ./src/components/payer/splash/styles.js